<template>
  <div>
    <div v-show="!showdetail">
      <div style="margin-top: 10px">
        <el-form
          ref="form"
          :model="dataForm"
          label-width="100px"
          label-position="left"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="订单编号"
                style="width: 90%; margin-left: 10%"
              >
                <el-input v-model="dataForm.oMain.JobNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="创建时间"
                style="width: 90%; margin-left: 10%"
              >
                <el-input v-model="dataForm.oMain.sCREATEDATE"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-table :data="dataForm.lItem" border style="width: 100%">
              <el-table-column
                prop="sno"
                label="序号"
                width="60"
                header-align="center"
                v-if="false"
              ></el-table-column>
              <el-table-column
                prop="skuid"
                label="skuid"
                width="160"
                header-align="center"
                v-if="false"
              ></el-table-column>
              <el-table-column
                prop="skuno"
                label="书号"
                width="160"
                header-align="center"
              ></el-table-column>
              <el-table-column
                prop="skuname"
                label="书名"
                width="600"
                header-align="center"
              ></el-table-column>
              <el-table-column
                prop="Sprice"
                label="价格"
                width="100"
                header-align="center"
                align="right"
              ></el-table-column>
              <el-table-column
                prop="newQuantity"
                label="订货数"
                width="80"
                header-align="center"
                align="right"
              ></el-table-column>
              <el-table-column
                prop="Quantity"
                label="原订数"
                width="80"
                header-align="center"
                align="right"
              ></el-table-column>
              <el-table-column
                prop="ChangeQuantity"
                label="变更数"
                width="80"
                header-align="center"
                align="right"
              ></el-table-column>
              <el-table-column
                prop="xzcheckusername"
                label="修正执行人"
                width="100"
                header-align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="xzcheckdate"
                label="修正时间"
                width="160"
              ></el-table-column>
              <el-table-column
                prop="Author"
                label="作者"
                width="280"
                header-align="center"
              ></el-table-column>
              <el-table-column
                prop="Publisher"
                label="版别"
                width="200"
                header-align="center"
              ></el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    @click="showorderitmedetail(scope.row)"
                    type="text"
                    size="small"
                    >商品详情</el-button
                  >
                </template>
              </el-table-column>

            </el-table>
          </el-row>
        </el-form>
      </div>
      <div style="margin-top: 20px; margin-bottom: 30px">
        <el-button @click="onmyexport()">导出EXCEL</el-button>
        <el-button
          type="primary"
          plain
          @click="goback()"
          style="font-size: 16px"
          >返回</el-button
        >
      </div>
    </div>

    <div v-if="showdetail">
      <div style="text-align: left" >
        <el-button
          type="primary"
          plain
          @click="gomain()"
          style="font-size: 16px"
          >返回</el-button
        >
      </div>

      <div>
        <skudetail :skupackobj="skuobj"></skudetail>
      </div>
    </div>
  </div>
</template>

<script>
// import mycartitem from "@/components/mycartitem.vue";
import axios from "axios";
import global from "../global.vue";
import AES from "../AES.js";
import XLSX from "xlsx";
import skudetail from "@/components/skudetail.vue";

export default {
  components: {
    skudetail,
  },

  data() {
    return {
      showdetail: false,
      skuobj: {},
      sexceldownfilename: "orderdetail.xlsx",
      jobno: "",
      dataForm: {
        sId: "",
        oMain: {
          JobNo: "",
          CustomerID: "",
          LinkMan: "",
          TelNo: "",
          Department: "",
          SumQuantity: "",
          Remark: "",
          CREATEUSERNAME: "",
          sCREATEDATE: "",
          sCustomerName: "",
          sorderState: "",
          StopFlag: "",
          DepartmentID: "",
        },
        lItem: [{}],
      },
    };
  },
  computed: {},
  created() {
    this.getParams();
    this.getdata();
  },
  methods: {
    showorderitmedetail(row) {
      console.log(row);
      console.log(row.skuid);

      var squery =
        '{"query": {"term": {"skuid.keyword": "' +
        row.skuid +
        '"}},"from": 0, "size": 10000}';
      var oquery = JSON.parse(squery);
      var stoken = window.localStorage.getItem("stoken");

      let that = this;

      axios({
        headers: { "Content-type": "application/json", token: stoken },
        method: "post",
        url: global.sserverip + "getSkuByFilterFromES",
        data: oquery,
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          console.log(res.data);
          var otmp = res.data.hits.hits[0]._source;
          console.log(otmp);
          otmp.supdateDate = global.dateFormat(
              otmp.updateDate,
              "yyyy-mm-dd hh:mm:ss"
            );
          that.skuobj = otmp;
          that.showdetail = true;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    gomain() {
      this.showdetail = false;
    },
    onmyexport: function () {
      let tableData = [
        ["书号", "书名", "作者", "版别", "价格", "订货数"], //导出表头
      ]; // 表格表头

      this.dataForm.lItem.forEach((item, index) => {
        let rowData = [];
        //导出内容的字段
        rowData = [
          item.skuno,
          item.skuname,
          item.Author,
          item.Publisher,
          item.Sprice,
          item.newQuantity,
        ];
        tableData.push(rowData);
      });

      //根据传参jdata和sfilename输出
      var wsname = "orderdetaildata";
      // var ws = XLSX.utils.json_to_sheet(this.dataForm.lItem);
      var ws = XLSX.utils.aoa_to_sheet(tableData);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, wsname);
      XLSX.writeFile(wb, this.sexceldownfilename);
    },
    goback() {
      location.assign(global.swebip + "qtindex/orderlist");
    },
    getParams() {
      this.jobno = this.$route.query.jobno;
    },
    getdata() {
      let that = this;
      var stoken = window.localStorage.getItem("stoken");
      // axios.defaults.headers.common["token"] = stoken;
      axios({
        headers: {
          "Content-type": "text/xml",
          token: stoken,
        },
        method: "post",
        url: global.sserverip + "getorderdetailbyjobno",
        data: that.jobno,
      })
        .then(function (res) {
          console.log(res.data);
          //TO-DO 先判断下数据是否正确 status
          that.dataForm = res.data;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
};
</script>


